<template>
  <div class="sequence-field col-12 mb-3"></div>
</template>

<script>
export default {};
</script>